import React from 'react';
import FormModel from "../form-model-manager";
import ErrorProto from "../../../gd/validation/error";
import FieldProto from "../../../fields3/proto/field-proto";

type Props = {
    form        : FormModel,
    fieldId?    : string, // this or field required
    field?      : FieldProto, // of fieldId
    className?  : string
}

// const debug = "FormFieldError"
const debug = false

export default class FormFieldError extends React.Component<Props,any> {

    constructor(props:Props) {
        super(props);

        this.state = {
            error: null
        }
    }

    private get fieldId():string {

        if (this.props.fieldId) return this.props.fieldId
        if (this.props.field) return this.props.field.fieldId

        return 'not-found'

    }

    public resetError():void {

        if (!this.state.error) return

        this.setState({
            error   : null
        })
    }

    public setError(error : ErrorProto | null):void {
        this.setState({
            error   : error
        })
    }

    componentDidMount() {
        this.props.form.registerErrorComponent(this.fieldId, this);
    }

    componentWillUnmount() {
        this.props.form.unRegisterErrorComponent(this.fieldId)
    }

    render() {

        debug && console.log(debug, "render() field.fieldId=", this.props.field?.fieldId, "fieldId=", this.props.fieldId)

        if (!this.props.form.displayErrors) return null
        if (!this.state.error) return null

        return (
            <div className={Classes('ui5-form-field-error', this.props.className)}>
                {this.state.error.message}
            </div>
        );

    }
}
